import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type InvitesStore = {
  invitesId: string | null;
  setInvitesId: (invitesId: string | null) => void;
  clearInvitesId: () => void;
};

export const useInvitesStore = create<InvitesStore>()(
  persist(
    (set) => ({
      invitesId: null,
      setInvitesId: (invitesId: string | null) => set({ invitesId }),
      clearInvitesId: () => set({ invitesId: null })
    }),
    {
      name: 'invites-id-storage'
    }
  )
);
